import Api from './api';

/**
 * Custom profanity word-list admin API.
 *
 * Thin wrappers over the shared `Api` client for the admin term-management
 * endpoints. All are admin-only; `{ silent: true }` so callers handle errors
 * inline (403 -> access-denied state) instead of the global error toast.
 *
 * Note: `REACT_APP_API_URL` already ends in `/api`, so paths start at `/admin`.
 */

const buildQuery = (filters = {}) => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '' && value !== 'all') {
      params.append(key, String(value));
    }
  });
  const qs = params.toString();
  return qs ? `?${qs}` : '';
};

/** GET /api/admin/moderation/terms/list -> { data: { items }, pagination } */
export const getProfanityTerms = (filters = {}) =>
  Api.get(`/admin/moderation/terms/list${buildQuery(filters)}`, null, { silent: true });

/** POST /api/admin/moderation/terms/create -> { data: ProfanityTerm, msg } */
export const createProfanityTerm = ({ term, level }) =>
  Api.post('/admin/moderation/terms/create', { term, level }, null, { silent: true });

/** POST /api/admin/moderation/terms/update/:termId -> { data: ProfanityTerm, msg } */
export const updateProfanityTerm = (termId, updates) =>
  Api.post(`/admin/moderation/terms/update/${termId}`, updates, null, { silent: true });

/** DELETE /api/admin/moderation/terms/remove/:termId -> { data: { deleted }, msg } */
export const removeProfanityTerm = (termId) =>
  Api.delete(`/admin/moderation/terms/remove/${termId}`, null, null, { silent: true });
